import React, { memo } from 'react';
import { Card, Stack, Typography } from 'investira.react.components';

const AvaliacoesGestorEditStatusView = memo(props => {
  const { title, description, helperText } = props;

  return (
    <Card sx={{ p: 4 }}>
      <Stack gap={1.5}>
        {title && (
          <Typography variant="h5" color="textPrimary">
            {title}
          </Typography>
        )}
        {description && (
          <Typography variant="body1" color="textSecondary">
            {description}
          </Typography>
        )}
        {helperText && (
          <Typography variant="body2" color="textSecondary">
            {helperText}
          </Typography>
        )}
      </Stack>
    </Card>
  );
});

export default AvaliacoesGestorEditStatusView;
